import React from "react";
import SkilledTechniciansImg from "../../Assets/Images/SkilledTechnicians.png";
import AffordablePricingImg from "../../Assets/Images/AffordablePricing.png";
import ReliableDiagnosticsImg from "../../Assets/Images/ReliableDiagnostics.png";
import LatestDiagnosticToolsImg from "../../Assets/Images/LatestDiagnosticTools.png";
import leftImg from "../../Assets/Images/WhyChooseUs_bg.png";

const WhyChooseUs = () => {
  const features = [
    {
      icon: SkilledTechniciansImg,
      title: "Skilled Technicians",
      desc: "Experienced professionals using advanced tools to ensure precision and quality in every service.",
    },
    {
      icon: AffordablePricingImg,
      title: "Affordable Pricing",
      desc: "High-quality vehicle care at prices that fit your budget—no hidden costs.",
    },
    {
      icon: ReliableDiagnosticsImg,
      title: "Reliable Diagnostics",
      desc: "State-of-the-art tools speed up the troubleshooting process and reduce guesswork.",
    },
    {
      icon: LatestDiagnosticToolsImg,
      title: "Latest Diagnostic Tools",
      desc: "Our workshops are equipped with advanced diagnostic systems that quickly detect issues in all vehicle models.",
    },
  ];

  return (
    <>
      <div className="">
        <div className="bg-[#0D0D0D] py-12 px-4 md:px-10 text-[#FFFFFF]">
          {/* Heading */}
          <div className="text-center mb-8">
            <p className="text-[#E8471B] font-montserrat font-medium text-[20px] leading-[24px] tracking-[0.5px] capitalize">
              Our Features
            </p>
            <h2 className="font-orbitron font-semibold text-[28px] md:text-[40px]">
              Why Choose Manika Automotive
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-5 items-center gap-6">
            {/* Left Image */}
            <div className="flex justify-center col-span-2">
              <img
                src={leftImg}
                alt="Technician"
                className="rounded-lg object-cover h-[570px] w-full"
              />
            </div>

            {/* Right Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 col-span-3">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-[#1A1A1A] rounded-lg p-6 flex flex-col gap-4 shadow-lg hover:shadow-xl transition-all duration-300 border-2 border-transparent hover:border-red-600 cursor-pointer"
                  style={{ minHeight: "260px" }}
                >
                  <div className="flex justify-center">
                    <img
                      src={feature.icon}
                      alt={feature.title}
                      className="object-contain"
                    />
                  </div>
                  <h3 className="font-orbitron text-center font-medium text-[24px] leading-[130%] tracking-[1px] capitalize text-[#FFFFFF]">
                    {feature.title}
                  </h3>
                  <p className="text-[#FFFFFF] font-montserrat font-normal text-[16px] leading-[24px] tracking-[0.5%] text-center">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhyChooseUs;
